// extracted by mini-css-extract-plugin
export default {"container":"BaseBox_container_caM3J","block":"BaseBox_block_ho6ix"};